import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import Icon from '../components/Icon';

const STATUS_BADGES = {
  active:    { icon: 'badge-active.png',    label: 'Active'     },
  paused:    { icon: 'badge-paused.png',    label: 'Paused'     },
  lead:      { icon: 'badge-lead.png',      label: 'Lead'       },
  completed: { icon: 'badge-completed.png', label: 'Completed'  },
};

function StatusBadge({ status }) {
  const b = STATUS_BADGES[status] || STATUS_BADGES.active;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <img src={'/icons/' + b.icon} alt={b.label} style={{ width: 16, height: 16, objectFit: 'contain' }}
        onError={(e) => e.target.style.display = 'none'} />
      <span style={{ fontSize: 12, color: 'var(--color-text-muted)', textTransform: 'capitalize' }}>{b.label}</span>
    </span>
  );
}

export default function Clients() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get('/clients')
      .then(setClients)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtered = clients.filter(c =>
    `${c.first_name} ${c.last_name}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <h1>
          <Icon name="nav-clients.png" />
          Clients
        </h1>
        <button className="icon-btn" onClick={() => navigate('/clients/new')} title="Add client">
          <Icon name="icon-add.png" alt="Add" />
        </button>
      </div>

      <div className="page-content">
        <div style={{ position: 'relative', marginBottom: 16 }}>
          <Icon name="icon-search.png" size={18} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', opacity: 0.5, pointerEvents: 'none' }} />
          <input
            className="form-input"
            style={{ paddingLeft: 40 }}
            placeholder="Search clients..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <div className="loading-spinner"><span className="spinner" /><span>Loading...</span></div>
        ) : filtered.length === 0 ? (
          <div className="empty-state">
            <Icon name="icon-user.png" size={48} style={{ opacity: 0.3 }} />
            <p>{search ? 'No clients match your search' : 'No clients yet'}</p>
            {!search && <button className="btn btn-primary" style={{ width: 'auto', padding: '0 24px' }} onClick={() => navigate('/clients/new')}>Add First Client</button>}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {filtered.map(client => (
              <div key={client.id} className="card" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 14 }}
                onClick={() => navigate('/clients/' + client.id)}>
                <img src="/icons/icon-user.png" alt=""
                  style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', background: 'var(--color-surface-2)', flexShrink: 0 }}
                  onError={(e) => e.target.style.display='none'} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>{client.first_name} {client.last_name}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <StatusBadge status={client.status} />
                    {client.last_session && (
                      <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>
                        Last: {new Date(client.last_session).toLocaleDateString()}
                      </span>
                    )}
                  </div>
                </div>
                <Icon name="icon-back.png" size={18} style={{ opacity: 0.3, transform: 'rotate(180deg)' }} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
